/**
 * Given an argument that may or may not be an array, returns an array of that
 * type.
 *
 * @example
 * const foo: string[] = makeArray(["foo", "bar"]);  // ["foo", "bar"]
 * const bar: string[] = makeArray("foo");           // ["foo"]
 */
export function makeArray<T>(input: T | T[]): T[] {
  return Array.isArray(input) ? input : [input];
}
